export default __webpack_public_path__ + "media/wallpaper/four-full-713c2a25.jpg";